import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  quranSvg: {
    width: "100%",
    height: "60%",
  },
  quranText: {
    fill: theme.palette.primary.dark,
  },
}));

const QuranQarim = () => {
  const classes = useStyles();

  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="600.000000pt"
      height="230.000000pt"
      viewBox="0 0 600.000000 230.000000"
      preserveAspectRatio="xMidYMid meet"
      className={classes.quranSvg}
    >
      <g
        className={classes.quranText}
        transform="translate(0.000000,230.000000) scale(0.100000,-0.100000)"
      >
        <path
          stroke="teal"
          d="M4417 2294 c-3 -3 -75 -9 -161 -13 -85 -3 -158 -10 -162 -14 -12 -11
24 -77 41 -77 9 0 25 4 35 10 10 5 67 17 127 25 59 9 122 18 140 21 32 5 63
27 63 45 0 10 -73 13 -83 3z"
        />
        <path
          d="M2720 2239 c-280 -42 -539 -111 -860 -231 -244 -91 -360 -154 -400
-221 -23 -38 -28 -156 -7 -197 20 -40 154 -145 257 -202 225 -124 624 -466
646 -554 3 -13 3 -31 0 -39 -10 -28 -107 -63 -286 -104 -228 -53 -244 -58
-315 -94 -122 -61 -224 -138 -391 -298 -147 -139 -184 -163 -265 -167 -81 -5
-105 6 -130 61 -35 79 -21 164 54 313 61 121 108 162 216 185 44 9 64 7 161
-17 100 -25 112 -27 126 -12 19 19 21 102 2 125 -7 9 -50 40 -95 70 -117 77
-153 133 -189 292 -8 36 -17 76 -19 89 -5 18 -1 22 20 22 14 0 28 -7 31 -15 8
-20 33 -19 41 0 5 15 -125 285 -138 285 -8 0 -39 -98 -39 -124 0 -12 16 -116
35 -230 37 -223 42 -293 23 -318 -7 -9 -51 -32 -97 -52 -119 -51 -221 -116
-335 -215 -284 -246 -486 -386 -576 -398 -38 -5 -43 -3 -84 39 -48 50 -72 117
-62 171 18 95 138 290 225 366 81 70 153 209 136 262 -8 25 -21 17 -45 -31
-40 -78 -101 -75 -141 7 -42 86 -28 202 62 532 28 100 48 185 45 188 -13 13
-30 -21 -96 -189 -93 -235 -103 -284 -104 -478 -1 -141 1 -159 22 -205 13 -27
21 -59 18 -71 -3 -12 -30 -61 -61 -109 -75 -119 -97 -182 -103 -288 -7 -132
32 -214 132 -272 134 -78 220 -47 457 162 189 167 364 303 391 303 5 0 1 -17
-8 -38 -51 -113 -63 -166 -64 -270 0 -114 9 -143 61 -186 42 -35 90 -55 155
-62 112 -14 150 10 414 260 79 76 160 144 180 153 19 8 134 41 255 73 121 32
245 68 276 79 89 34 141 101 156 202 12 79 2 153 -25 182 -37 39 -25 40 47 2
83 -44 195 -134 215 -174 12 -22 15 -63 14 -177 -1 -168 13 -232 72 -323 91
-143 224 -192 456 -170 128 12 240 40 376 95 60 24 113 42 117 39 5 -2 19 -33
31 -67 35 -95 67 -137 130 -169 64 -33 117 -37 203 -14 83 22 129 54 304 216
152 141 248 190 501 260 79 21 148 42 154 45 6 4 42 -25 82 -64 39 -39 84 -76
99 -81 40 -15 152 -13 216 3 94 26 166 88 189 166 32 106 21 337 -39 800 -21
168 -39 328 -39 355 l1 50 39 -45 40 -45 0 44 c0 70 -126 352 -160 359 -21 4
-40 -51 -40 -114 0 -68 20 -243 85 -731 67 -514 70 -541 56 -575 -17 -43 -89
-116 -128 -129 -50 -16 -176 -4 -230 22 l-43 21 66 56 c36 30 72 69 81 85 18
36 37 225 28 287 -5 34 -17 54 -50 87 -37 38 -48 43 -86 43 -139 0 -224 -175
-199 -409 l4 -44 -159 -52 c-88 -28 -178 -61 -200 -72 -22 -11 -55 -24 -72
-28 -18 -3 -33 -10 -33 -15 0 -4 -19 -18 -43 -29 -23 -11 -88 -61 -144 -110
-196 -171 -280 -230 -371 -260 -95 -32 -146 -10 -177 78 -32 91 -18 117 114
223 170 137 199 175 221 291 18 96 9 167 -34 264 -20 45 -36 84 -36 88 0 3 20
3 45 -1 29 -4 45 -3 45 4 0 6 -27 46 -59 89 -92 120 -109 139 -117 130 -14
-14 -17 -178 -4 -235 7 -30 32 -103 57 -161 53 -124 57 -163 24 -210 -40 -56
-182 -170 -239 -191 -29 -11 -76 -32 -105 -46 -83 -43 -243 -100 -362 -129
-185 -47 -325 -25 -455 71 -92 68 -150 176 -150 278 0 71 8 72 96 15 272 -179
405 -169 502 38 27 57 27 60 25 248 -1 156 -7 228 -33 405 -59 401 -70 510
-52 510 5 0 21 -14 36 -31 68 -76 49 33 -39 216 -84 177 -84 177 -79 -5 14
-454 28 -646 74 -995 11 -82 20 -185 20 -227 0 -76 0 -78 -31 -93 -43 -23
-120 -30 -173 -16 -46 11 -212 106 -253 144 -20 17 -23 31 -23 91 l0 71 -26
-32 c-17 -23 -34 -33 -52 -33 -32 0 -45 8 -172 110 -213 170 -405 296 -550
360 -160 70 -456 239 -476 271 -18 30 135 130 236 153 36 9 137 40 225 70 222
76 459 133 730 176 144 23 275 6 275 -35 0 -25 -126 -152 -200 -200 -83 -56
-250 -225 -250 -254 0 -35 24 -24 87 38 33 32 104 91 159 132 169 124 231 189
280 294 33 69 31 115 -5 154 -28 30 -31 31 -118 30 -48 0 -144 -9 -213 -20z
m2452 -1289 c48 -14 78 -52 78 -100 0 -46 -22 -68 -110 -109 -74 -35 -73 -36
-96 53 -17 63 -18 132 -2 142 11 7 62 21 83 23 6 0 27 -4 47 -9z"
        />
        <path
          d="M470 2134 c-46 -26 -110 -82 -110 -96 0 -4 56 -8 124 -8 120 0 176
-9 176 -29 0 -5 -47 -26 -105 -46 -57 -21 -110 -44 -116 -52 -45 -54 146 -23
256 42 81 47 155 149 128 176 -17 17 -146 39 -228 39 -67 0 -87 -4 -125 -26z"
        />
        <path
          d="M1540 2111 c-127 -50 -310 -146 -360 -189 -67 -57 -89 -122 -52 -155
31 -29 42 -21 42 31 0 40 5 53 29 76 17 16 130 79 253 140 122 61 224 117 226
124 6 21 -39 13 -138 -27z"
        />
        <path
          d="M3490 2125 c-24 -62 -8 -348 36 -640 67 -452 75 -527 81 -772 3 -134
9 -243 14 -243 14 0 36 51 58 139 39 158 29 319 -52 841 -53 333 -61 406 -49
414 5 3 27 -8 48 -25 49 -39 55 -24 24 58 -24 66 -113 224 -135 243 -12 10
-16 8 -25 -15z"
        />
        <path
          d="M4234 2119 c-33 -64 -18 -258 76 -974 45 -338 51 -400 53 -538 1 -55
6 -98 12 -100 34 -8 48 325 25 606 -9 111 -58 564 -75 690 -6 43 3 46 35 12
31 -33 44 -19 36 40 -7 42 -95 233 -129 279 -14 19 -15 18 -33 -15z"
        />
        <path
          d="M3960 2100 c-14 -9 -28 -81 -29 -146 -1 -47 -10 -57 -109 -124 -59
-39 -91 -80 -65 -80 17 0 133 75 182 118 28 23 58 42 68 42 40 0 45 13 33 84
-6 37 -16 76 -22 86 -14 22 -40 31 -58 20z"
        />
        <path
          d="M5784 2068 c-30 -46 -5 -440 52 -833 63 -438 67 -477 69 -795 2 -216
6 -305 14 -304 26 2 31 5 42 27 27 50 38 146 39 333 0 230 -15 390 -80 839
-44 309 -54 392 -51 435 1 9 16 -1 41 -25 36 -36 42 -38 56 -24 14 15 13 23
-15 95 -44 112 -124 258 -143 262 -9 2 -20 -3 -24 -10z"
        />
        <path
          d="M4532 2008 c-30 -30 -7 -91 42 -112 25 -11 43 -31 71 -80 20 -36 41
-66 46 -66 16 0 29 42 37 123 9 88 1 108 -18 44 l-12 -41 -32 35 c-17 20 -45
53 -62 73 -33 38 -52 44 -72 24z"
        />
        <path
          d="M5045 1996 c-13 -13 -29 -42 -36 -65 -11 -36 -10 -43 6 -61 10 -11
29 -20 42 -20 22 0 23 -2 11 -19 -27 -38 -206 -193 -291 -252 -48 -33 -86 -66
-84 -72 7 -21 38 -19 53 2 9 12 21 21 29 21 7 0 33 15 58 34 24 19 54 39 66
46 12 6 67 51 122 101 78 70 106 89 130 89 36 0 47 21 27 53 -8 12 -18 49 -22
81 -4 33 -12 66 -18 73 -17 21 -66 15 -93 -11z"
        />
        <path
          d="M750 1720 c-23 -46 -25 -85 -5 -120 25 -44 18 -70 -29 -114 -24 -23
-93 -67 -154 -100 -115 -60 -162 -96 -127 -96 9 0 74 28 144 62 98 48 138 73
178 115 41 41 59 53 83 53 40 0 47 21 21 63 -12 20 -21 51 -21 74 0 104 -51
140 -90 63z"
        />
        <path
          d="M2254 1734 c-12 -3 -29 -13 -39 -24 -15 -17 -15 -21 -1 -49 18 -34
105 -106 246 -203 106 -74 137 -102 121 -113 -15 -9 -103 32 -227 106 -114 68
-197 136 -220 180 -20 40 -64 41 -64 2 0 -34 77 -109 176 -171 132 -83 298
-172 321 -172 26 0 63 32 63 55 0 38 -37 79 -137 151 -165 119 -215 163 -211
188 5 33 64 33 138 0 40 -18 64 -24 71 -17 13 13 3 36 -23 52 -22 14 -173 24
-214 15z"
        />
        <path
          d="M3878 1693 c-15 -16 -34 -41 -42 -57 -13 -25 -13 -33 -1 -55 20 -38
101 -114 114 -107 6 4 23 27 37 52 l27 46 -20 42 c-22 44 -70 106 -82 106 -4
0 -19 -12 -33 -27z"
        />
        <path
          d="M2943 1657 c-65 -84 -86 -184 -44 -218 62 -50 141 14 141 116 0 29
-6 39 -32 55 -21 12 -35 30 -38 47 l-5 27 -22 -27z"
        />
        <path
          d="M4875 1470 c-26 -51 -20 -77 36 -131 28 -27 54 -49 58 -49 12 0 101
97 101 110 0 5 -27 30 -61 55 -75 55 -111 59 -134 15z"
        />
        <path
          d="M5142 1484 c-29 -20 -55 -70 -47 -94 8 -26 80 -88 111 -96 20 -5 32
-1 54 22 46 47 46 67 4 114 -31 34 -80 70 -96 70 -2 0 -14 -7 -26 -16z"
        />
        <path
          d="M3077 1330 c-22 -26 -46 -101 -47 -148 -1 -11 -7 -6 -17 13 -29 53
-62 91 -97 110 -29 16 -37 17 -50 6 -19 -16 -20 -44 -5 -74 15 -28 28 -37 57
-37 17 0 33 -16 63 -65 59 -93 67 -88 80 42 5 46 14 93 20 104 11 21 19 21 77
4 19 -6 22 -4 22 17 0 30 -28 58 -57 58 -12 0 -32 -13 -46 -30z"
        />
        <path
          d="M887 1175 c-16 -15 -31 -73 -43 -164 l-7 -54 -33 65 c-64 128 -146
180 -151 98 -3 -40 6 -54 60 -95 23 -17 51 -53 68 -87 46 -91 68 -79 93 52 9
47 21 95 26 107 9 22 10 23 45 6 46 -22 64 -8 45 37 -20 48 -72 66 -103 35z"
        />
        <path
          d="M4666 1128 c-7 -13 -24 -53 -35 -90 -12 -37 -31 -78 -42 -92 -26 -33
-24 -50 9 -85 42 -46 76 -45 126 3 48 44 48 78 1 129 -35 38 -36 40 -29 98 7
64 -4 77 -30 37z"
        />
        <path
          d="M1805 1086 c-13 -13 -34 -57 -47 -100 -13 -42 -25 -76 -28 -76 -3 0
-18 25 -35 56 -48 89 -102 124 -128 83 -17 -27 0 -64 41 -87 53 -29 68 -49 81
-107 7 -28 16 -57 22 -65 20 -31 61 50 99 198 10 39 14 43 33 37 66 -21 85 3
42 54 -32 37 -48 39 -80 7z"
        />
        <path
          d="M2317 463 c-16 -16 -4 -54 29 -95 60 -70 74 -111 74 -215 0 -152 41
-125 48 32 3 75 0 100 -18 148 -32 85 -106 157 -133 130z"
        />
        <path
          d="M5599 264 c-11 -14 -10 -18 5 -30 27 -20 13 -73 -35 -134 -23 -29
-39 -54 -36 -57 9 -8 61 24 93 59 63 66 84 147 45 168 -28 15 -57 12 -72 -6z"
        />
        <path
          d="M1920 214 l-55 -55 54 -51 c60 -55 86 -68 135 -68 41 0 76 35 76 75
0 23 -14 43 -66 92 -36 35 -71 63 -77 63 -7 0 -37 -25 -67 -56z"
        />
        <path
          d="M1662 224 c-49 -59 -48 -71 12 -131 65 -65 101 -71 147 -22 31 33 37
65 17 91 -24 31 -113 98 -130 98 -9 0 -30 -16 -46 -36z"
        />
      </g>
    </svg>
  );
};

export default QuranQarim;
